module.exports = __webpack_public_path__ + "img/contact-linz-1.665af7e.svg?v=1764327952164";